console.log("[password-field] initialized");

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".password-toggle");
  if (!btn) return;

  const input = document.getElementById(btn.dataset.target);
  if (!input) return;

  const show = input.type === "password";
  input.type = show ? "text" : "password";
  btn.setAttribute("aria-pressed", show ? "true" : "false");

  const on  = btn.querySelector("[data-eye-on]");
  const off = btn.querySelector("[data-eye-off]");
  if (on && off) {
    on.style.display  = show ? "none" : "";
    off.style.display = show ? "" : "none";
  }
});
